import { core } from '@icc/shared/helpers';
import { IWindowConfiguration } from '../window-configuration';
import { DoorConfiguration } from '../door-configuration';

export function changesInVersion24(
    oldConfiguration: any,
): IWindowConfiguration {
    const configuration: IWindowConfiguration = {
        ...core.copy(oldConfiguration),
    };

     if (configuration.type === 'door') {
            (configuration as DoorConfiguration).doorHardware = {
                ...(configuration as DoorConfiguration).doorHardware,
                doorViewerColor: null,
                doorViewerColorIsDefault: true
            }
        }

    return configuration;
}